import React, { Component } from "react";
import sample_01 from "../public/images/sample_01.png";
import sample_02 from "../public/images/sample_02.png";
import sample_03 from "../public/images/sample_03.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Badge } from "reactstrap";
import Fade from "react-reveal/Fade";
import Slide from "react-reveal/Slide";
import { faGithub } from "@fortawesome/fontawesome-free-brands";

class Samples extends Component {
  render() {
    const projectsData = [
      {
        name: "Notes App",
        description: (
          <>
            A web application that lets you create and store notes for later
            purpose. I used{" "}
            <a
              href="https://ant.design/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Ant Design
            </a>{" "}
            here for the UI design.
          </>
        ),
        image: sample_01,
        imageSize: "80%",
        demoLink: "https://mg-notes-app.web.app/",
        codeLink: "https://github.com/markanjo05/mg-notes-app",
        techs: ["React", "Redux"],
      },
      {
        name: "Simple Posting App",
        description: (
          <>
            A simple social media application that lets you share and view
            posts, images and expressions. Infinite scroll feature is also
            supported to limit excessive API calls. I used{" "}
            <a
              href="https://mui.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Material UI
            </a>{" "}
            here for the UI design.
          </>
        ),
        image: sample_02,
        imageSize: "80%",
        demoLink: "https://simplepostingapp-mg.web.app/login",
        codeLink: "https://github.com/markanjo05/simplepostingapp",
        techs: ["React", "Redux", "Firebase"],
      },
      {
        name: "Plants Website",
        description: (
          <>
            A responsive website about plants. I just used plain css here to
            style elements.
          </>
        ),
        image: sample_03,
        imageSize: "80%",
        demoLink: "https://markgalisa-greeno.web.app/",
        codeLink: "https://github.com/markanjo05/plants-website",
        techs: ["React"],
      },
    ];

    return (
      <div
        className="tools-container text-center m-auto"
        id="samples"
        name="samples"
      >
        <div className="component-top-margin">
          <Fade up>
            <h1 className="common-component-title mb-5">SAMPLES</h1>
          </Fade>
          {projectsData.map((project, idx) => {
            const isLast = idx + 1 === projectsData.length;

            return (
              <Slide left>
                <Row
                  className={`justify-content-center portfolio-works ${
                    isLast ? "" : "portfolio-border-bottom"
                  }`}
                >
                  <Col
                    lg={6}
                    // className={project.isImgAlignCenter ? "" : "text-lg-right"}
                  >
                    <img
                      src={project.image}
                      alt={project.name}
                      width={project.imageSize}
                      className="mb-lg-0 mb-4 img-fluid"
                      loading="lazy"
                    />
                  </Col>
                  <Col lg={6} className="text-left align-self-center">
                    <h3>{project.name}</h3>
                    <div className="d-block mb-3">
                      <div className="d-flex align-items-center">
                        {project.techs.map((tech) => {
                          return (
                            <Badge color="info" className="mr-2">
                              {tech}
                            </Badge>
                          );
                        })}
                      </div>
                    </div>
                    <p className="mt-3">{project.description}</p>
                    <a
                      className="btn btn-info rounded-0 projects-btn main-btn-color"
                      href={project.demoLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon
                        icon={faExternalLinkAlt}
                        className="mr-2"
                      />
                      Demo
                    </a>
                    <a
                      className="btn btn-dark rounded-0 projects-btn ml-3"
                      href={project.codeLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon={faGithub} className="mr-2" />
                      View Code
                    </a>
                  </Col>
                </Row>
              </Slide>
            );
          })}
        </div>
      </div>
    );
  }
}

export default Samples;
